import { render } from "./SliderLiveTv.vue?vue&type=template&id=c54d2d08"
import script from "./SliderLiveTv.vue?vue&type=script&lang=js"
export * from "./SliderLiveTv.vue?vue&type=script&lang=js"

import "./SliderLiveTv.vue?vue&type=style&index=0&id=c54d2d08&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__